import styles from "./loading.module.scss";
import { LoadIndicator } from "devextreme-react/load-indicator";
import logogray from "assets/icons/logogray.png";
import gif5 from "assets/gifs/5.gif";

function Component() {
  return (
    <div className={styles.main}>
      <div className={styles.logo}>
        <img src={logogray} width="75" height="48" alt="" />
      </div>
      <div className={styles.logo}>
        <LoadIndicator indicatorSrc={gif5} height={15} width={120} />
      </div>
    </div>
  );
}

export default Component;
